import React from 'react'

import type { AppProps } from 'next/app'
import { LogoJsonLd } from 'next-seo'
import { ThemeProvider } from 'styled-components'

import { useSetRDIFrameTitle, useStyleRDCookiesBanner } from '@/hooks'
import { InternationalizationProvider } from '@/store/internationalization'
import { PageContextProvider } from '@/store/pageContext'
import { ScreenProvider } from '@/store/screen'
import { ResetStyle } from '@/styles/base'
import { defaultTheme } from '@/styles/themes'

const App = ({ Component, pageProps }: AppProps) => {
  useSetRDIFrameTitle()
  useStyleRDCookiesBanner()

  return (
    <ThemeProvider theme={defaultTheme}>
      <ScreenProvider>
        <InternationalizationProvider>
          <PageContextProvider>
            <LogoJsonLd
              logo="https://nh-site-strapi-bucket.s3.amazonaws.com/nata_90e1b7d6d6.png"
              url="https://www.natahouse.com"
            />
            <Component {...pageProps} />
            <ResetStyle />
          </PageContextProvider>
        </InternationalizationProvider>
      </ScreenProvider>
    </ThemeProvider>
  )
}

export default App
